import moment from "moment"

import $exceptionHandler from "./$exception-handler"

export function config(
  $logProvider: angular.ILogProvider,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  environment: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  $provide: any,
): void {
  "ngInject"

  moment.suppressDeprecationWarnings = true

  $provide.decorator("$exceptionHandler", $exceptionHandler)

  // Enable log
  $logProvider.debugEnabled(environment.debugLogging)
}
